import styled from 'styled-components';
import DownloadMobileApp from './DownloadMobileApp';
import { colorSchema } from 'utils/style';

export default styled(DownloadMobileApp)`
  .download-mobile-app {
    background-color: ${colorSchema('white')};
    border-top: 1px solid ${colorSchema('grey900')};
    margin: 0 -1rem;
    padding: 2rem;
    height: 100vh;

    &__header {
      display: flex;
      flex-direction: column;
      margin-top: 2rem;
      align-items: center;
      svg {
        fill: ${colorSchema('primary')};
      }
      img {
        margin-top: 2rem;
      }
    }
    &__footer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 3rem;

      &__option {
        margin: 0 0.5rem;
      }
    }
  }
`;
